import { BASE_API_URL } from 'js/constants/App';

export const sendEmailData = ({ email, first_name, last_name }) => {
  const url = `${BASE_API_URL}signup`;

  return fetch(url, {
    method: 'POST',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8',
    },
    body: new URLSearchParams({ email, first_name, last_name }).toString(),
  })
    .then(async (response) => {
      const text = await response.text();
      let parsed;

      try {
        parsed = text ? JSON.parse(text) : {};
      } catch (e) {
        parsed = text;
      }

      if (!response.ok) {
        return {
          result: 'FAILURE',
          reason: parsed?.message || parsed || 'An unknown error occurred.',
        };
      }

      return { result: 'SUCCESS', payload: parsed };
    })
    .catch((error) => {
      return { result: 'FAILURE', reason: error?.message || error };
    });
};

export const fetchGalleryData = () => {
  const url = `${BASE_API_URL}get-approved/gallery`;

  return fetch(url, {
    method: 'GET',
    headers: {
      Accept: 'application/json',
    },
  })
    .then(async (response) => {
      const text = await response.text();
      let parsed;

      try {
        parsed = text ? JSON.parse(text) : {};
      } catch (e) {
        parsed = text;
      }

      console.log('response.ok:', response.ok, 'parsed response:', parsed);

      if (!response.ok) {
        return {
          result: 'FAILURE',
          reason: parsed?.message || parsed || 'An unknown error occurred.',
        };
      }

      return { result: 'SUCCESS', payload: parsed };
    })
    .catch((error) => {
      return { result: 'FAILURE', reason: error?.message || error };
    });
};

export const enterGalleryData = (data) => {
  const url = `${BASE_API_URL}enter/gallery`;

  return fetch(url, {
    method: 'POST',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(data),
  })
    .then(async (response) => {
      const text = await response.text();
      let parsed;

      try {
        parsed = text ? JSON.parse(text) : {};
      } catch (parseError) {
        parsed = text;
      }

      if (!response.ok) {
        return {
          result: 'FAILURE',
          reason: parsed?.message || 'An unknown error occurred.',
        };
      }

      return { result: 'SUCCESS', payload: parsed.message };
    })
    .catch((error) => {
      console.log('Error entering gallery data:', error);

      if (typeof error === 'string') {
        return { result: 'FAILURE', reason: error };
      }

      return { result: 'FAILURE', reason: error?.message || 'An unknown error occurred.' };
    });
};

export const fetchYoutubePlaylistsData = () => {
  const url = `${BASE_API_URL}fetch_youtube_playlists`;

  return fetch(url, {
    method: 'GET',
    headers: {
      Accept: 'application/json',
    },
  })
    .then(async (response) => {
      const text = await response.text();
      let parsed;

      try {
        parsed = text ? JSON.parse(text) : {};
      } catch (e) {
        parsed = text;
      }

      if (!response.ok) {
        return {
          result: 'FAILURE',
          reason: parsed?.message || parsed || 'An unknown error occurred.',
        };
      }

      return { result: 'SUCCESS', payload: parsed };
    })
    .catch((error) => {
      return { result: 'FAILURE', reason: error?.message || error };
    });
};
